import React, { useContext, useEffect, useState } from "react";

import styles from "./ModalDetallesEventoTemporada.module.css";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { ModalConfirmacionCompra } from "../ModalConfirmacionCompra/ModalConfirmacionCompra";
import { decryptBase64ArrayByteToString } from "../../../Commons/EncriptText";
import Form from "react-bootstrap/esm/Form";
import Loading from "../../../General/Loading";

import {
  builtConsultaHorarioPPEEntrada,
  ConsultaHorarioPPE_Entrada,
  ConsultaHorarioPPE_Parametros,
  ConsultaHorarioPPE_Respuesta,
} from "../../../Commons/Services/ConsultaHorarioPPE";
import { ConsultaWS } from "../../../Commons/ServiciosBase";

import {
  builtRecargaConsultaPrecioRecargaInput,
  AltaServicioPPE_Entrada,
  AltaServicioPPE_Parametros,
  AltaServicioPPE_Respuesta,
} from "../../../Commons/Services/AltaServicioPPE";
import ConfirmMessage from "../../../General/ConfirmMessage";
import {
  DatosFiscales as DatosFiscalesCrearSolicitud,
  builtDatosFiscales as builtDatosFiscalesCrearSolicitud,
  Direccion as DireccionCrearSolicitud,
  builtDireccion as builtDireccionCrearSolicitud,
  Llave,
  builtLlave,
  ListaLlaves,
  builtListaLlaves,
  InfoPPE as InfoPPECrearSolicitud,
  builtInfoPPE as builtInfoPPECrearSolicitud,
  DetallesSolicitudDeServicio,
  builtDetallesSolicitudDeServicio,
  CrearSolicitud_Entrada,
  builtCrearSolicitud_Entrada,
  CrearSolicitud_Parametros,
  CrearSolicitud_Respuesta,
} from "../../../Commons/Services/CrearSolicitud";
import {
  ConsultaHorariosPagoPorEventoRest_Entrada,
  builtConsultaHorariosPagoPorEventoRestEntrada,
  ConsultaHorariosPagoPorEventoRest_Respuesta,
  ConsultaHorariosPagoPorEventoRest_Parametros,
  Horario,
} from "../../../Commons/Services/ConsultaHorariosPagoPorEventoRest";
import {
  builtSolicitudDeServicio,
  SolicitudDeServicio,
  builtContratacionServicios,
  ContratacionServicios,
  AltaSolicitudDeServicio_Entrada,
  builtAltaSolicitudDeServicio_Entrada,
  AltaSolicitudDeServicio_Parametros,
  AltaSolicitudDeServicio_Respuesta,
  CambioFormaPago,
  builtCambioFormaPago,
  DatosFiscales,
  builtDatosFiscales,
  Direccion,
  builtDireccion,
  CompraControlRemoto,
  builtCompraControlRemoto,
  ActivaRemoteBooking,
  builtActivaRemoteBooking,
  InfoPPE,
  builtInfoPPE,
  Pagos,
  builtPagos,
  DatosTDC,
  builtDatosTDC,
  RespuestaACI,
  builtRespuestaACI,
} from "../../../Commons/Services/AltaSolicitudDeServicioRest";
import Select from "react-select";

import { ListaTarjetasInteligente } from "../../../Commons/Services/ConsultarTICorporativo";
export const ModalDetallesEventoTemporada = ({
  show,
  handleClose,
  titulo,
  precio,
  canal,
  canalDisplay,
  idioma,
  subtitulos,
  img,
  sinopsis,
  area,
  subarea,
  aviso,
}: any) => {
  const [muestraModal, setMuestraModal] = useState(false);
  const [tarjetas, setTarjetas] = useState<any>([]);
  const [dataHorarios, setDataHorarios] = useState<any>([]);
  const [horarios, setHorarios] = useState<any>([]);
  const [seleccionTarjeta, setSeleccionTarjeta] = useState("0");
  const [seleccionHorario, setSeleccionHorario] = useState("0");

  const [loading, isLoading] = useState(false);

  const [status1, setStatus1] = useState("OK");
  const [message1, setMessage1] = useState("");
  const [showAlert1, setShowAlert1] = useState(false);
  const [showModalAviso, setShowModalAviso] = useState(false);
  interface TIEstructure {
    value: string;
    label: string;
  }
  const handleCloseHijo = () => setMuestraModal(false);
  const [info, setInfo] = useState<TIEstructure[]>([]);
  const [allTI, setAllTI] = useState<TIEstructure[]>([]);

  const handleShow = () => {
    if (sessionStorage.getItem("esCuentaCorporativa") === "V") {
      if (sessionStorage.getItem("esCuentaCorporativaJerarquia") === "false") {
        if (info.length > 0 && seleccionHorario !== "0") {
          setMuestraModal(true);
        } else {
          setStatus1("ERROR");
          setMessage1("Favor de elegir horario y equipo");
          setShowAlert1(true);
          setTimeout(() => {
            setShowAlert1(false);
          }, 3000);
        }
      } else {
        if (seleccionTarjeta !== "0" && seleccionHorario !== "0") {
          setMuestraModal(true);
        } else {
          setStatus1("ERROR");
          setMessage1("Favor de elegir horario y equipo");
          setShowAlert1(true);
          setTimeout(() => {
            setShowAlert1(false);
          }, 3000);
        }
      }
    } else {
      if (seleccionTarjeta !== "0" && seleccionHorario !== "0") {
        setMuestraModal(true);
      } else {
        setStatus1("ERROR");
        setMessage1("Favor de elegir horario y equipo");
        setShowAlert1(true);
        setTimeout(() => {
          setShowAlert1(false);
        }, 3000);
      }
    }
  };

  const obtieneTarjeta = (e: any) => {
    setSeleccionTarjeta(e.target.value);
  };

  const obtieneHorario = (e: any) => {
    setSeleccionHorario(e.target.value);
  };

  useEffect(() => {
    //doConsultaHorarioPPE();
    doConsultaHorariosPagoPorEventoRest();

    if (sessionStorage.getItem("esCuentaCorporativa") === "V") {
      if (sessionStorage.getItem("esCuentaCorporativaJerarquia") === "false") {
        let esCuentaPadreTI: ListaTarjetasInteligente[] = JSON.parse(
          sessionStorage.getItem("esCuentaCorporativaTI")!
        );

        if (esCuentaPadreTI != null && esCuentaPadreTI.length > 0) {
          for (let i = 0; i < esCuentaPadreTI.length; i++) {
            let buffer: TIEstructure = {
              value: esCuentaPadreTI[i].NumeroTarjetaInteligente,
              label: esCuentaPadreTI[i].NumeroTarjetaInteligente,
            };
            allTI.push(buffer);
          }
        }
      }
    }
  }, []);

  const doConsultaHorariosPagoPorEventoRest = async () => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------
      const ConsultaHorariosPagoPorEventoRestEntrada: ConsultaHorariosPagoPorEventoRest_Entrada =
        builtConsultaHorariosPagoPorEventoRestEntrada(
          canal,
          "ALL DAY",
          titulo,
          sessionStorage.getItem("pais")!,
          sessionStorage.getItem("diferenciaGMT")!
        );
      let ConsultaHorariosPagoPorEventoRestParametros =
        ConsultaHorariosPagoPorEventoRest_Parametros(
          ConsultaHorariosPagoPorEventoRestEntrada
        );

      let ConsultaHorariosPagoPorEventoRestRespuesta: ConsultaHorariosPagoPorEventoRest_Respuesta =
        await ConsultaWS(ConsultaHorariosPagoPorEventoRestParametros);

      if (
        ConsultaHorariosPagoPorEventoRestRespuesta.Horarios &&
        ConsultaHorariosPagoPorEventoRestRespuesta.Horarios != null &&
        ConsultaHorariosPagoPorEventoRestRespuesta.Horarios.length > 0
      ) {
        setDataHorarios(ConsultaHorariosPagoPorEventoRestRespuesta.Horarios);
        let arreglo: string[] = [];
        let data = ConsultaHorariosPagoPorEventoRestRespuesta.Horarios;
        let anio: string = "";
        let mes: string = "";
        let dia: string = "";
        let hora: string = "";

        data.forEach((element: Horario) => {
          anio = element.START_DATE.substring(0, 4);
          mes = element.START_DATE.substring(5, 7);
          dia = element.START_DATE.substring(8, 10);
          hora = element.START_DATE.substring(11, 16);

          arreglo.push(dia + "-" + mes + "-" + anio + " | " + hora);
        });

        setHorarios(arreglo);
      } else {
        console.error(ConsultaHorariosPagoPorEventoRestRespuesta);
      }
      let tarjetas: any = "";
      if (sessionStorage.getItem("tarjetas") !== null) {
        tarjetas = sessionStorage.getItem("tarjetas");
      }
      if (tarjetas !== "") {
        let arTarjetas = JSON.parse(tarjetas);

        arTarjetas.forEach((element: any, index: number) => {
          if (
            element.Categoria === "SKY IPC UHD" ||
            element.Categoria === "SKY HMC EHD"
          ) {
            arTarjetas.splice(index, index);
          }
        });
        setTarjetas(arTarjetas);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      console.error(error);
      // Expected output: ReferenceError: nonExistentFunction is not defined
      // (Note: the exact output may be browser-dependent)
    }
  };

  const handleContratrarPPE = () => {
    if (sessionStorage.getItem("esCuentaCorporativa") === "V") {
      if (sessionStorage.getItem("esCuentaCorporativaJerarquia") === "false") {
        doCrearSolicitud();
        info.map((item: TIEstructure, index: number) => {
          doAltaSolicitudDeServicio(item.value);
        });
      } else {
        doAltaSolicitudDeServicio(seleccionTarjeta);
      }
    } else {
      doAltaSolicitudDeServicio(seleccionTarjeta);
    }
  };

  const doAltaSolicitudDeServicio = async (p_tiseleccionada: string) => {
    let index: number = parseInt(seleccionHorario) - 1;
    let objetoHorario: Horario = dataHorarios[index];

    let cadenaInicio = objetoHorario.START_DATE;
    let cadenaFin = objetoHorario.END_DATE;

    let cadenaInicioArray = cadenaInicio.split("T");
    let cadenaInicioFechaArray = cadenaInicioArray[0].split("-");
    let horaInicio = cadenaInicioArray[1].slice(0, 5);
    let fechaInicio =
      cadenaInicioFechaArray[2] +
      "/" +
      cadenaInicioFechaArray[1] +
      "/" +
      cadenaInicioFechaArray[0];

    let cadenaFinArray = cadenaFin.split("T");
    let cadenaFinFechaArray = cadenaFinArray[0].split("-");
    let horaFin = cadenaFinArray[1].slice(0, 5);
    let fechaFin =
      cadenaFinFechaArray[2] +
      "/" +
      cadenaFinFechaArray[1] +
      "/" +
      cadenaFinFechaArray[0];

    let horaInicioArray = horaInicio.split(":");
    let horaFinArray = horaFin.split(":");

    let fechaHoraInicio =
      cadenaInicioFechaArray[0] +
      cadenaInicioFechaArray[1] +
      cadenaInicioFechaArray[2] +
      horaInicioArray[0] +
      horaInicioArray[1];

    let fechaHoraFin =
      cadenaFinFechaArray[0] +
      cadenaFinFechaArray[1] +
      cadenaFinFechaArray[2] +
      horaFinArray[0] +
      horaFinArray[1];
    //----------------------------------------------------------------------------------------------------------------------------
    isLoading(true);
    const cambioFormaPago: CambioFormaPago = builtCambioFormaPago(
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ""
    );

    const datosFiscales: DatosFiscales = builtDatosFiscales("", "", "", "", "");
    const direccion: Direccion = builtDireccion("", "", "", "", "", "", "", "");

    const contratacionServicios: ContratacionServicios =
      builtContratacionServicios(
        sessionStorage.getItem("Paquete")!,
        "",
        "",
        "",
        "",
        "N"
      );

    const compraControlRemoto: CompraControlRemoto = builtCompraControlRemoto(
      "",
      "",
      "",
      "",
      ""
    );

    const activaRemoteBooking: ActivaRemoteBooking = builtActivaRemoteBooking(
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ""
    );

    const infoPPE: InfoPPE = builtInfoPPE(
      titulo,
      "Sky Premiere",
      precio,
      fechaInicio + " a las " + horaInicio,
      fechaFin + " a las " + horaFin,
      canalDisplay,
      canal,
      objetoHorario.PPV_EVENT_ID.toString(),
      fechaHoraFin,
      fechaHoraInicio,
      objetoHorario.DURATION.toString()!,
      sessionStorage.getItem("diferenciaGMT")!,
      "0",
      objetoHorario.TOKEN_VALUE.toString(),
      objetoHorario.PPV_GENRE_ID.toString(),
      objetoHorario.PROVIDER_EVENT_ID,
      objetoHorario.ORDER_TYPE,
      objetoHorario.SKYTrackingId
    );

    const datosTDC: DatosTDC = builtDatosTDC("", "", "", "", "", "");

    const respuestaACI: RespuestaACI = builtRespuestaACI(
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ""
    );

    const pagos: Pagos = builtPagos("", "", "", datosTDC, respuestaACI);

    const solicitudDeServicio: SolicitudDeServicio = builtSolicitudDeServicio(
      `${sessionStorage.getItem("cuenta")}`,
      area,
      subarea,
      "APP SKY- " + titulo,
      p_tiseleccionada,
      sessionStorage.getItem("rowId")!,
      sessionStorage.getItem("Usuario")!,
      sessionStorage.getItem("pais")!,
      sessionStorage.getItem("accountType")!,
      sessionStorage.getItem("NombreSuscriptor")!,
      datosFiscales,
      direccion,
      contratacionServicios,
      compraControlRemoto,
      activaRemoteBooking,
      infoPPE,
      pagos,
      cambioFormaPago,
      "HIJUMP",
      sessionStorage.getItem("idSesion")!
    );
    const AltaSolicitudDeServicioEntrada: AltaSolicitudDeServicio_Entrada =
      builtAltaSolicitudDeServicio_Entrada(solicitudDeServicio);
    let AltaSolicitudDeServicioParametros = AltaSolicitudDeServicio_Parametros(
      AltaSolicitudDeServicioEntrada
    );

    let AltaSolicitudDeServicioRespuesta: AltaSolicitudDeServicio_Respuesta =
      await ConsultaWS(AltaSolicitudDeServicioParametros);

    if (
      AltaSolicitudDeServicioRespuesta.NumeroSolicitud &&
      AltaSolicitudDeServicioRespuesta.NumeroSolicitud != null &&
      AltaSolicitudDeServicioRespuesta.NumeroSolicitud !== ""
    ) {
      setStatus1("OK");
      setMessage1(
        "Servicio contrato exitosamente " +
          AltaSolicitudDeServicioRespuesta.NumeroSolicitud
      );
      setShowAlert1(true);
      setTimeout(() => {
        setShowAlert1(false);
        setSeleccionTarjeta("0");
      }, 3000);
    } else {
      console.error(AltaSolicitudDeServicioRespuesta);
      setStatus1("ERROR");
      setMessage1(AltaSolicitudDeServicioRespuesta.resultadodesc);
      setShowAlert1(true);
      setTimeout(() => {
        setShowAlert1(false);
        setSeleccionTarjeta("0");
      }, 3000);
    }
    isLoading(false);
    //----------------------------------------------------------------------------------------------------------------------------
  };

  const doCrearSolicitud = async () => {
    let index: number = parseInt(seleccionHorario) - 1;
    let objetoHorario: Horario = dataHorarios[index];

    let cadenaInicio = objetoHorario.START_DATE;
    let cadenaFin = objetoHorario.END_DATE;

    let cadenaInicioArray = cadenaInicio.split("T");
    let cadenaInicioFechaArray = cadenaInicioArray[0].split("-");
    let horaInicio = cadenaInicioArray[1].slice(0, 5);
    let fechaInicio =
      cadenaInicioFechaArray[2] +
      "/" +
      cadenaInicioFechaArray[1] +
      "/" +
      cadenaInicioFechaArray[0];

    let cadenaFinArray = cadenaFin.split("T");
    let cadenaFinFechaArray = cadenaFinArray[0].split("-");
    let horaFin = cadenaFinArray[1].slice(0, 5);
    let fechaFin =
      cadenaFinFechaArray[2] +
      "/" +
      cadenaFinFechaArray[1] +
      "/" +
      cadenaFinFechaArray[0];

    let horaInicioArray = horaInicio.split(":");
    let horaFinArray = horaFin.split(":");

    let fechaHoraInicio =
      cadenaInicioFechaArray[0] +
      cadenaInicioFechaArray[1] +
      cadenaInicioFechaArray[2] +
      horaInicioArray[0] +
      horaInicioArray[1];

    let fechaHoraFin =
      cadenaFinFechaArray[0] +
      cadenaFinFechaArray[1] +
      cadenaFinFechaArray[2] +
      horaFinArray[0] +
      horaFinArray[1];
    try {
      var arrayllave: Llave[] = [];
      info.map((item: TIEstructure, index: number) => {
        var llave: Llave = builtLlave(item.value);
        arrayllave.push(llave);
      });

      var listaLlaves: ListaLlaves = builtListaLlaves(arrayllave);

      var infoPPE: InfoPPECrearSolicitud = builtInfoPPECrearSolicitud(
        fechaHoraFin,
        objetoHorario.PROVIDER_EVENT_ID,
        objetoHorario.ORDER_TYPE,
        fechaHoraInicio,
        titulo,
        precio,
        canal,
        "Sky Premiere",
        fechaFin + " a las " + horaFin,
        "0",
        objetoHorario.TOKEN_VALUE.toString(),
        fechaInicio + " a las " + horaInicio,
        objetoHorario.DURATION.toString()!,
        objetoHorario.SKYTrackingId,
        canalDisplay,
        objetoHorario.PPV_EVENT_ID.toString(),
        sessionStorage.getItem("diferenciaGMT")!,
        objetoHorario.PPV_GENRE_ID.toString()
      );
      var direccion: DireccionCrearSolicitud = builtDireccionCrearSolicitud(
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      );
      var datosFiscales: DatosFiscalesCrearSolicitud =
        builtDatosFiscalesCrearSolicitud("", "", "", "", "", "", "", "");

      var detallesSolicitudDeServicio: DetallesSolicitudDeServicio =
        builtDetallesSolicitudDeServicio(
          "Administracion de senal",
          sessionStorage.getItem("NombreSuscriptor")!, //
          datosFiscales,
          "",
          sessionStorage.getItem("TipoCuenta")!,
          direccion,
          infoPPE,
          "Solicitud de OPPV",
          sessionStorage.getItem("Usuario")!,
          sessionStorage.getItem("pais")!
        );

      var crearSolicitud_Entrada: CrearSolicitud_Entrada =
        builtCrearSolicitud_Entrada(
          listaLlaves,
          sessionStorage.getItem("esCuentaCorporativaNombreCorporativo")!,
          detallesSolicitudDeServicio,
          "SEL"
        );
      //----------------------------------------------------------------------------------------------------------------------------

      let CrearSolicitudParametros = CrearSolicitud_Parametros(
        crearSolicitud_Entrada
      );

      let CrearSolicitudRespuesta: CrearSolicitud_Respuesta = await ConsultaWS(
        CrearSolicitudParametros
      );

      if (CrearSolicitudRespuesta.resultadodesc !== "0") {
        console.info("Solicitud generada correctamente");
      } else {
        console.error("Solicitud generada sin exito");
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      console.error(error);
      // Expected output: ReferenceError: nonExistentFunction is not defined
      // (Note: the exact output may be browser-dependent)
    }
  };

  const setUserChoice = (p_choice: any) => {
    setInfo(p_choice);
  };

  return (
    <>
      <Loading isLoading={loading} />
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header
          closeButton
          style={{ borderBottom: "none" }}
        ></Modal.Header>
        <Modal.Body className={styles.contenedor}>
          <Row className={styles["alertContainer"]}>
            <Col>
              <ConfirmMessage
                status={status1}
                message={message1}
                showAlert={showAlert1}
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <div id="big" className="d-none d-xl-block d-lg-block ">
                <img src={img} className={styles.img} />
              </div>
              <div id="small" className="d-lg-none d-xl-none">
                <img src={img} className={styles.img} />
              </div>
            </Col>
            <Col md={8}>
              <div className={styles.info}>
                <h2 className={styles.titulo}>
                  {titulo.length > 28 ? titulo.slice(0, 28) : titulo}
                </h2>
                <span>Canal {canal}</span>
                <p>${precio} | All day</p>
                <p className={styles.descripcion}>{sinopsis}</p>
                <p className={styles.descripcion}>
                  <strong>
                    {" "}
                    Idioma {idioma} | Subtítulos {subtitulos}
                  </strong>
                </p>
                <Row>
                  <Col xs={12} lg={4} className={styles.colSelect}>
                    <Form.Select
                      aria-label="Default select example"
                      className={styles.select}
                      onChange={obtieneHorario}
                    >
                      <option value="0">Horario</option>
                      {horarios.map((hora: any, key: number) => {
                        return <option value={key + 1}>{hora}</option>;
                      })}
                    </Form.Select>
                  </Col>

                  {sessionStorage.getItem("esCuentaCorporativa") === "V" ? (
                    sessionStorage.getItem("esCuentaCorporativaJerarquia") ===
                    "false" ? (
                      <Select
                        defaultValue={[allTI[2], allTI[3]]}
                        isMulti
                        name="colors"
                        options={allTI}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        onChange={(choice: any) => setUserChoice(choice)}
                      />
                    ) : (
                      <Col xs={12} lg={4}>
                        <Form.Select
                          aria-label="Default select example"
                          className={styles.selectTarjeta}
                          onChange={obtieneTarjeta}
                        >
                          <option value="0">Tarjeta inteligente</option>
                          {tarjetas.map((tarjeta: any) => {
                            return (
                              <option value={tarjeta.TarjetaInteligente}>
                                {tarjeta.TarjetaInteligente}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </Col>
                    )
                  ) : (
                    <Col xs={12} lg={4}>
                      <Form.Select
                        aria-label="Default select example"
                        className={styles.selectTarjeta}
                        onChange={obtieneTarjeta}
                      >
                        <option value="0">Tarjeta inteligente</option>
                        {tarjetas.map((tarjeta: any) => {
                          return (
                            <option value={tarjeta.TarjetaInteligente}>
                              {tarjeta.TarjetaInteligente}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Col>
                  )}

                  <Col xs={12} lg={4}>
                    <Button
                      className={styles.boton}
                      onClick={(event) => {
                        handleShow();
                        //handleClose();
                      }}
                    >
                      Contratar
                    </Button>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <ModalConfirmacionCompra
        show={muestraModal}
        handleClose={handleCloseHijo}
        handleCloseContratar={handleClose}
        contratar={handleContratrarPPE}
        titulo={titulo}
        precio={precio}
      />
    </>
  );
};
